import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

import objectFitImages from 'object-fit-images';
objectFitImages();

document.querySelectorAll('.hirowa-event--slider').forEach(slider => {
    const wrapper = slider.querySelector('.swiper-wrapper');
    const slides = slider.querySelectorAll('.hirowa-event__item');
    slides.forEach(item => {
        item.classList.add('swiper-slide');
    });
    
    let nowSlides = slides.length;
    while (nowSlides < 14) {
        nowSlides += slides.length;
        slides.forEach(item => {
            wrapper.appendChild(item.cloneNode(true));
        });
    }
    
    new Swiper(slider, {
        modules: [ Navigation, Autoplay ],
        slidesPerView: 1.5,
        centeredSlides: true,
        loop: true,
        autoplay: { delay: 3000 },
        speed: 800,
        spaceBetween: 16,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            520: {
                spaceBetween: 24,
                slidesPerView: 2.1,
            },
            960: {
                spaceBetween: 32,
                slidesPerView: 3.5,
            },
            960: {
                spaceBetween: 32,
                slidesPerView: 4.5,
            }
        }
    });
});

const eventCardItems = document.querySelectorAll('.hirowa-event:not(.hirowa-event--vertical) .hirowa-event__item');
if (eventCardItems.length > 0) {
    const nowTime = dayjs();
        
    eventCardItems.forEach(item => {
        let insertNode = item.querySelector('.hirowa-event__link');
        if (!insertNode) {
            insertNode = item;
        }
        
        let badgeClassName = 'hirowa-event__badge--none';
        let badgeText = '　';
        let targetDate = null;
        let isEventDate = false;
        
        if (item.dataset.eventDate) {
            const eventDateAt = dayjs(item.dataset.eventDate);
        
            if (nowTime.format('YYYY-MM-DD') === eventDateAt.format('YYYY-MM-DD')) {
                isEventDate = true;
                targetDate = eventDateAt;
                badgeText = eventDateAt.format('M月D日');
            }
        }
        
        if (!isEventDate && item.dataset.periodStart && item.dataset.periodEnd) {
            const periodStartAt = dayjs(item.dataset.periodStart);
            const periodEndAt = dayjs(item.dataset.periodEnd);
            
            if (!nowTime.isBefore(periodStartAt) && !nowTime.isAfter(periodEndAt)) {
                targetDate = periodEndAt;
                badgeText = periodEndAt.format('M月D日');
            }
        }

        if (targetDate) {
            if (isEventDate) {
                badgeText = '開催中';
            } else if (item.dataset.periodSuffix) {
                badgeText += `<br>${item.dataset.periodSuffix}`;
            } else {
                badgeText += 'まで';
            }
            
            const badge = document.createElement('time');
            badge.className = 'hirowa-event__card-badge';
            badge.setAttribute('datetime', targetDate.format('YYYY-MM-DD 00:00:00'));
            badge.innerHTML = badgeText;
            insertNode.insertBefore(badge, insertNode.firstChild);
        }
        
    });
}

const eventItems = document.querySelectorAll('.hirowa-event--vertical .hirowa-event__item');
if (eventItems.length > 0) {
    const nowTime = dayjs();
    const dayOfWeek = [ '日', '月', '火', '水', '木', '金', '土', ];
    
    document.querySelectorAll('.hirowa-event--vertical .hirowa-event__item').forEach(item => {
        let insertNode = item.querySelector('.hirowa-event__link');
        if (!insertNode) {
            insertNode = item;
        }
        
        let badgeClassName = 'hirowa-event__badge--none';
        let badgeText = '　';
        let isEventDate = false;
        
        if (item.dataset.eventDate) {
            const eventDateAt = dayjs(item.dataset.eventDate);
            const timeNode = document.createElement('time');
            timeNode.className = 'hirowa-event__date';
            timeNode.setAttribute('datetime', eventDateAt.format('YYYY-MM-DD 00:00:00'));
            timeNode.appendChild(document.createTextNode(eventDateAt.format('YYYY年M月D日') + '（' + dayOfWeek[eventDateAt.day()] + '）'));
            insertNode.insertBefore(timeNode, insertNode.firstChild);

            if (nowTime.format('YYYY-MM-DD') === eventDateAt.format('YYYY-MM-DD')) {
                isEventDate = true;
                badgeClassName = 'hirowa-event__badge--event-date';
                badgeText = '開催中';
            } else if (nowTime.isAfter(eventDateAt)) {
                isEventDate = true;
                badgeClassName = 'hirowa-event__badge--after-event';
                badgeText = '終　了';
            }
        }
        
        if (!isEventDate && item.dataset.periodStart && item.dataset.periodEnd) {
            const periodStartAt = dayjs(item.dataset.periodStart);
            const periodEndAt = dayjs(item.dataset.periodEnd);
            
            if (nowTime.isBefore(periodStartAt)) {
                badgeClassName = 'hirowa-event__badge--before-period';
                badgeText = '募集前';
            } else if (nowTime.isAfter(periodEndAt)) {
                badgeClassName = 'hirowa-event__badge--after-period';
                badgeText = '開催前';
            } else {
                badgeClassName = 'hirowa-event__badge--period';
                badgeText = '募集中';
            }
        }
        
        const badge = document.createElement('p');
        badge.className = `hirowa-event__badge ${badgeClassName}`;
        badge.appendChild(document.createTextNode(badgeText));
        insertNode.insertBefore(badge, insertNode.firstChild);

        const moreButton = document.createElement('p');
        moreButton.className = 'hirowa-event__more';
        moreButton.innerHTML = 'more<svg class="hirowa-event__more-arrow" viewBox="0 0 10 19"><path style="stroke-width:0px;" d="m.31,1.98l6.96,7.51L.35,17.03c-.43.47-.41,1.22.06,1.66.46.44,1.19.42,1.63-.06l7.66-8.35c.41-.45.41-1.15,0-1.6L1.99.37C1.55-.1.82-.12.36.32c-.46.44-.48,1.19-.05,1.66Z"></svg>';
        insertNode.appendChild(moreButton);
    });
}

